import { HireStep, useHireStepLabels, useHireSteps } from "@/pages/employees/hire/hire-context";
import { Stack, Text } from "@skailer-com/uikit";

interface HireSidebarProps {
  step: HireStep;
}

export function HireSidebar({ step }: HireSidebarProps) {
  const labels = useHireStepLabels();
  const steps = useHireSteps();

  return (
    <Stack className={"px-6"} gap={"md"}>
      {steps.map((item) => (
        <Text key={item} className={item === step ? "text-default" : "text-secondary"}>
          {labels[item]}
        </Text>
      ))}
    </Stack>
  );
}
